import styled from 'styled-components';

export const StyledStagedVideo = styled.div.attrs(props => ({
className: props.className
}))`
/* Code Here */
`;